module.exports = __webpack_public_path__ + "static/img/hujiao2.28146c6.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/images/bottom/black/hujiao2.png
// module id = VT2r
// module chunks = 24